// extracted by mini-css-extract-plugin
export default {"linkWithBookmarkContainer":"ReportLinkWithFavouritesCell_linkWithBookmarkContainer__FC8dM","reportName":"ReportLinkWithFavouritesCell_reportName__xWmrr"};